import { compose } from 'recompose';
import _property from 'lodash/property';
import _isFinite from 'lodash/isFinite';

var invalidNumberToZero = function invalidNumberToZero(value) {
  return _isFinite(value) ? value : 0;
};

var displayValue = _property('displayValue');

var entity = _property('data');

var id = _property('id');

var entities = _property('entities');

var count = compose(invalidNumberToZero, _property('count'));
var LOOKUP_READER = {
  displayValue: displayValue,
  entity: entity,
  id: id,
  entities: entities,
  count: count
};
export default LOOKUP_READER;